module.exports = __webpack_public_path__ + "static/kelebek-3cec84a3b309906854c083fa1f339dab.png";